import { Avatar, Box, HStack, Stack, Text } from "@chakra-ui/react";
import { KYDOrganizationCompact } from "@common/interfaces/KYDOrganization";
import { KYDOrganizationUser } from "@common/interfaces/KYDUser";
import { useEffect, useState } from "react";

interface UserProfileProps {
  currentUser: KYDOrganizationUser;
  onOrganizationClick: () => void;
}

export const UserProfile = (props: UserProfileProps) => {
  const { currentUser, onOrganizationClick } = props;
  const [currentOrganization, setCurrentOrganization] =
    useState<KYDOrganizationCompact>();

  useEffect(() => {
    if (currentUser) {
      const _currentOrganization = currentUser.organizations.find(
        (org) => org.id === currentUser.organization_id
      );

      setCurrentOrganization(_currentOrganization);
    }
  }, [currentUser]);

  return (
    <Stack spacing="3">
      {currentOrganization ? (
        <HStack
          p={4}
          borderWidth={"1px"}
          borderColor={"gray.300"}
          rounded={"lg"}
          cursor={"pointer"}
          onClick={onOrganizationClick}
        >
          {currentOrganization.type === "business" ? (
            <>
              <Avatar
                src={currentOrganization.logo_url}
                name={currentOrganization.name}
                size="sm"
              />
              <Text fontWeight={"bold"}>{currentOrganization.name}</Text>
            </>
          ) : (
            <Text fontWeight={"bold"}>Personal</Text>
          )}
        </HStack>
      ) : null}
      {currentUser.email ? (
        <Box
          p={4}
          borderWidth={"1px"}
          borderColor={"gray.300"}
          rounded={"lg"}
          cursor={"pointer"}
          onClick={onOrganizationClick}
        >
          <Text fontWeight="medium" fontSize="md" color="gray.800">
            {`${currentUser.first_name} ${currentUser.last_name}`}
          </Text>
          <Text
            fontSize="md"
            color="gray.500"
            noOfLines={1}
            textOverflow="ellipsis"
            wordBreak="break-all"
          >
            {currentUser.email}
          </Text>
        </Box>
      ) : null}
    </Stack>
  );
};
